import { Component, OnInit, Input } from '@angular/core';
import { MainComponent } from '../../main.component';
import { Router } from '@angular/router';
import { SearchObjectService } from '../../../../shared/services/search-object.service';

@Component({
  selector: 'app-tab-navigation',
  templateUrl: './tab-navigation.component.html',
  styleUrls: ['./tab-navigation.component.scss']
})
export class TabNavigationComponent implements OnInit {
  constructor(public parent: MainComponent, private router: Router, private searchObjectService: SearchObjectService) {
  }

  @Input() page;
  @Input() type;

  ngOnInit() {
  }

  setTab(route: string, id) {
    if (route === 'find' || route === 'findpcp') {
      this.searchObjectService.getLoginData();
    } else {
      this.searchObjectService.getBrowseData();
    }
    localStorage.removeItem('isCaptchaShow');
    this.router.navigate([route]);
    if (id) {
      setTimeout(function() {
      document.getElementById(id).focus();
    }, 500);
  }
}

}
